import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import Navbar from "../Components_UBMeEvents/Navbar/Navbar";
import Footer from "../Components_UBMeEvents/Footer/Footer";
import QRCode from "qrcode";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import AddToAppleWalletImage from "../../../images/Add_to_Apple_Wallet.png";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./AddToWallet.css";
import {axiosE} from "../../../Service/service";
import moment from "moment-timezone";
import ErrorPage from "../../../Helper/ErrorPage/errorPage";
import { routeName } from "Service/env";
import * as constants from "Constants";

// Custom Next Arrow
const NextArrow = ({ onClick, currentSlide, slideCount }) => {
    return (
        <div
            className={`custom-arrow right-arrow ${
                currentSlide === slideCount - 1 ? "disabled" : ""
            }`}
            onClick={onClick}
        >
            <FaChevronRight />
        </div>
    );
};

// Custom Prev Arrow
const PrevArrow = ({ onClick, currentSlide }) => {
    return (
        <div
            className={`custom-arrow left-arrow ${currentSlide === 0 ? "disabled" : ""}`}
            onClick={onClick}
        >
            <FaChevronLeft />
        </div>
    );
};

const AddToWallet = ({ match }) => {
    const OrderId = match.params.OrderId;

    const [eventInfo, setEventInfo] = useState(null);
    const [tickets, setTickets] = useState([]);
    const [qrImages, setQrImages] = useState([]);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [error, setError] = useState(false);

    // Fetch tickets and event info
    useEffect(() => {
        if (!OrderId) return;

        const fetchTickets = async () => {
            try {
                const res = await axiosE.get(`GetWalletTicketsByOrderId/${OrderId}`);
                const data = res.data.results;

                if (data.ResponseCode) {
                    const convertedDate = moment.utc(data.EventStartDateTime)
                        .tz(data.TimeZone)
                        .format("dddd, MMMM DD, YYYY hh:mm A");

                    setEventInfo({
                        EventName: data.EventName,
                        EventStartDateTime: convertedDate,
                        VenueName: data.VenueName,
                        Address: data.Address,
                        EventMediumImage: data.EventMediumImage
                    });
                    setTickets(data.Tickets || []);
                } else {
                    console.error("API error:", data.Message);
                    setError(true); // 👈 show error UI instead
                }
            } catch (err) {
                console.error("Error fetching tickets:", err);
                setError(true);
            }
        };

        fetchTickets();
    }, [OrderId]);

    // Generate QR codes
    useEffect(() => {
        const generateQRCodes = async () => {
            const results = await Promise.all(
                tickets.map((ticket) =>
                    QRCode.toDataURL(ticket.QRCodeId, {
                        errorCorrectionLevel: "H",
                        type: "image/png",
                        width: 200,
                        color: { dark: "#000", light: "#fff" },
                    })
                )
            );
            setQrImages(results);
        };

        if (tickets.length > 0) generateQRCodes();
    }, [tickets]);

    const [validPkPass, setValidPkPass] = useState({});

    useEffect(() => {
        tickets.forEach(ticket => {
            if (ticket.PkPassFileName) {
                fetch(ticket.PkPassFileName, { method: "HEAD" }) // HEAD request just checks if file exists
                    .then(res => {
                        setValidPkPass(prev => ({
                            ...prev,
                            [ticket.QRCodeId]: res.ok
                        }));
                    })
                    .catch(() => {
                        setValidPkPass(prev => ({
                            ...prev,
                            [ticket.QRCodeId]: false
                        }));
                    });
            }
        });
    }, [tickets]);

    // Track window resize
    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const showArrows = windowWidth > 500;

    const settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: showArrows,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
    };

    return (
        <div className="add-to-wallet-page">
            {error ? (
                <ErrorPage />
            ) : (
                <>
                    <Navbar />

                    <div className="wallet-slider-container">
                        <Slider {...settings}>
                            {tickets.map((ticket, index) => (
                                <div key={index}>
                                    <div className="ticket-card">
                                        <div className="card-content">
                                            <img src={eventInfo.EventMediumImage} alt={eventInfo.EventName} className="ticket-image" />
                                            <h2>{eventInfo.EventName}</h2>
                                            <p>{eventInfo.EventStartDateTime}</p>
                                            <p>{eventInfo.VenueName} - {eventInfo.Address}</p>

                                            <div className="center-content">
                                                {qrImages[index] && (
                                                    <img src={qrImages[index]} alt={`QR ${ticket.TicketName}`} className="ticket-qr" />
                                                )}
                                                <p className="ticket-type">
                                                    {ticket.TicketName}
                                                    {ticket.AddOns && ticket.AddOns.length > 0 && (
                                                        " - " + ticket.AddOns.map(addon => addon.Name).join(", ")
                                                    )}
                                                </p>

                                                {validPkPass[ticket.QRCodeId] && (
                                                    <img
                                                        src={AddToAppleWalletImage}
                                                        alt="Add to Apple Wallet"
                                                        className="apple-wallet-btn"
                                                        onClick={() => {
                                                            console.log("Apple Wallet button clicked")
                                                            // Open in a new tab
                                                            // window.open(ticket.PkPassFileName, "_blank");

                                                            const ua = navigator.userAgent || navigator.vendor || window.opera;

                                                            const isSafari = /Safari/i.test(ua) && !/CriOS|FxiOS|EdgiOS|OPiOS/i.test(ua);
                                                            const isChrome = /CriOS/i.test(ua);
                                                            const isFirefox = /FxiOS/i.test(ua);
                                                            const isEdge = /EdgiOS/i.test(ua);
                                                            const isOpera = /OPiOS/i.test(ua);

                                                            const isStandaloneBrowser = isSafari || isChrome || isFirefox || isEdge || isOpera;

                                                            try {
                                                                const absoluteUrl = new URL(ticket.PkPassFileName, window.location.href).href;

                                                                if (isStandaloneBrowser) {
                                                                    // Directly open in Safari, Chrome, Firefox, Edge, Opera
                                                                    window.location.href = absoluteUrl;
                                                                } else {
                                                                    // In-app browser (Gmail, Yahoo, Outlook, FB, IG, etc.)
                                                                    const redirectUrl = `${constants.URLs.hostName+routeName}/open-in-safari?url=${encodeURIComponent(
                                                                        absoluteUrl
                                                                    )}`;
                                                                    window.location.href = redirectUrl;
                                                                }
                                                            } catch (err) {
                                                                console.error("Invalid PkPassFileName:", ticket.PkPassFileName, err);
                                                                alert("Sorry — the ticket link is invalid.");
                                                            }
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>

                    <Footer />
                </>
            )}
        </div>
    );
};

export default AddToWallet;
